// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"students-table_tableHead__2Qlqu","table":"students-table_table__3iMqc","tableData":"students-table_tableData__8n116"};